module.exports = __webpack_public_path__ + "static/media/pattern1.0bc75929.svg";